(ns ncr.search.bottombar
  (:require
   [clojure.core.match :refer [match]]
   [ncr.etc.util :as u]
   [ncr.etc.pf :as pf]
   [ncr.fragment.props.money :as props.money]
   [ncr.search.selection :as sel]
   [ncr.widgets.datev]
   [ncr.etc.profile-pspec :as pspec]))

(defn c-bottom-bar [props {:keys [stat fragments-by-id]}]
  (let
    [selected (sel/use-selected)
     selected-fragments (vals (select-keys fragments-by-id selected))
     selected-count (count selected)
     has-selected? (> selected-count 0)
     fragments-count (count fragments-by-id)]

    [pf/c-toolbar props
     [pf/c-toolbar-content
      (let [{:keys [sum count]} stat]
        [:<>
         [pf/c-toolbar-group {:variant :button-group}
          [pf/c-toolbar-item {:variant :label}
           [:span
            (if-not has-selected?
              (u/format "Count: %s" count)
              (u/format "Selected: %s (%s)" selected-count count))
            (when (> count fragments-count)
              [pf/c-tooltip
               {:content
                (str "The number of matching fragments is too large to display, only first "
                  fragments-count " are shown. Refine your search criteria to narrow down number of fragments.")}
               [:span.ncr-search-truncated
                [:i
                 {:icon "information-outline"
                  :class [:mdi :mdi-information-outline]}]
                "limit"]])]]]
         [pf/c-toolbar-group {:variant :button-group :alignment {:default :align-right}}
          [pf/c-toolbar-item {:variant :label}
           "\u03a3 "
           [:span.ncr-c-total-amount
            {:class (when @(pspec/use-search-blur-sensitive) :ncr-m-blurred)}
            (if-not has-selected?
              (u/format "%s" (props.money/to-string sum))
              (u/format "%s (%s)"
                (props.money/to-string
                  (reduce
                    (fn [^js acc fragment]
                      (if-let [value (get-in fragment [:properties :common/netto])]
                        (.plus acc value)
                        acc))
                    (u/bignumber "0.00")
                    selected-fragments))
                (props.money/to-string sum)))]]]])]]))